import { useEffect, useState } from 'react';
import WriteEssay from '../../../../Essay/pages/Writing';
import { useDailyScheduleContentStore } from '../../../stores/useDailyScheduleContent';
import ScheduleEssayTheme from './components/EssayTheme';
import { useCreateEssay } from '../../../../Essay/hooks/useCreateEssay';
import { useEssayScheduleStore } from '../../../stores/essayScheduleStore';
import { useConcludeScheduleEssayHook } from '../../../hooks/EssaySchedule/useConcludeScheduleEssayHook';
import { toast } from '../../../../../core/components/atoms/Toast';
import { useParams } from 'react-router-dom';

export function PAEssayPage() {
  const { mutate, data, isPending } = useCreateEssay();
  const { finishEssay, isError: isErrorFinishEssay, isSuccess } = useConcludeScheduleEssayHook();

  const { scheduleId } = useParams();
  const { essaySchedule } = useEssayScheduleStore();

  const [isWriting, setIsWriting] = useState(false);

  const selectedContent = useDailyScheduleContentStore(
    (s) => s.selectedContent
  );

  const onStart = () => {
    if (essaySchedule) {
      mutate({ theme: essaySchedule.themeId || '', moduleOrigin: 'plan' });
    }
  };

  const onFinish = () => {
    if (essaySchedule && scheduleId) {
      finishEssay({ 
        cronogramaId: scheduleId, 
        essayThemeId: essaySchedule.id 
      });
    }
  };

  useEffect(() => {
    if (data && data.ok) {
      setIsWriting(true);
    }
  }, [data]);

  useEffect(() => {
    setIsWriting(false);
  }, [selectedContent?.content.id]);

  useEffect(() => {
    if (isErrorFinishEssay) {
      toast({
        variant: 'error',
        message: 'Erro ao concluir a redação',
        title: 'Erro!',
        position: 'top-right',
      });
    }
  }, [isErrorFinishEssay]);

  useEffect(() => {
    if (isSuccess) {
      window.location.reload();
    }
  }, [isSuccess]);

  if (!selectedContent) {
    return <></>;
  }

  if (isWriting) {
    return (
      <WriteEssay
        key={selectedContent.content.id}
        origin='course'
        slug={essaySchedule?.slug || ''}
        className='!w-auto !px-4'
        footerType='embedded'
        onBack={() => setIsWriting(false)}
        showBackButton={true}
        finish={onFinish}
      />
    );
  }

  return <ScheduleEssayTheme onStart={onStart} loading={isPending} />;
}
